import { uniqueId } from 'lodash';
import createReducer from 'common/reducerBase';
import { filterArrayProp, pushToArrayProp } from 'utils/seamlessUtils';
import { types } from '../actions';
import UploadQueueRecord from '../data/UploadQueueRecord';

const getUpdatedQueueIds = (state, payload) => {
  const newIds = payload.ids.filter((id) => !~state.queueIds.indexOf(id));

  return newIds.length ? pushToArrayProp(state, 'queueIds', newIds) : state;
};

const getUpdatedQueueItems = (state, payload) => {
  Object.keys(payload.items).forEach((id) => {
    state = state.setIn(['queueItems', id], payload.items[id]);
  });

  return state;
};

export default createReducer(UploadQueueRecord(), {
  [types.SET_QUEUE_ITEMS]: (state, { payload }) => {
    state = getUpdatedQueueIds(state, payload);
    state = getUpdatedQueueItems(state, payload);

    if (typeof payload.simulated !== 'undefined' && payload.simulated !== state.simulatedQueue) {
      state = state.set('simulatedQueue', payload.simulated);
    }

    return state;
  },

  [types.CLEAR_QUEUE]: (state) => state.merge(UploadQueueRecord()),

  [types.SET_QUEUE_ITEMS_RETRY]: (state, { payload }) => state.set('retryIds', payload && payload.ids ? payload.ids : [uniqueId('*')]),

  [types.SET_QUEUE_ITEMS_ABORT]: (state, { payload }) => state.set('abortIds', payload && payload.ids ? payload.ids : [uniqueId('*')]),

  [types.ADD_UPLOAD_TO_QUEUE]: (state, { payload }) => {
    state = pushToArrayProp(state, ['added', 'files'], payload.files);

    if (payload.cropInfo) {
      state = pushToArrayProp(state, ['added', 'cropInfo'], payload.cropInfo);
    }
    return state;
  },

  [types.CLEAR_CANCELLED_UPLOADS]: (state, { payload }) =>
    state.added && state.added.files ? filterArrayProp(state, ['added', 'files'], (i) => !~payload.files.indexOf(i)) : state,
});
